import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer w-screen">
      <div className="content-container">
        <p>&copy; 2026 Gabinet CUDAki. Wszystkie prawa zastrzeżone.</p>
      </div>
    </footer>
  );
};

export default Footer;